import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import propTypes from 'prop-types';

//import components
import LoadingIndicator from '../../components/LoadingIndicator.js';
import Error505Page from '../Error505Page.js';
import NewsAll from './NewsAll.js';

class NewsSubpage extends Component {
    static defaultProps = {
        ipp: 6
    };

    constructor(props) {
        super(props);

        this.state = {
            totalPages: 1,
            pageNum: 1,
        };
    };

    componentDidUpdate(prevProps) {
        const {id, pageData, ipp, searchValue} = this.props;

        if (pageData &&
            ((prevProps.id !== id)
            || (prevProps.pageData && pageData.length !== prevProps.pageData.length)
            || !prevProps.pageData
            || (prevProps.searchValue !== searchValue))) {

            this.setState({pageNum: 1});
            this.setState({totalPages: Math.ceil(pageData.length/ipp)});
        }
    };

    setNextPage = () => {
        const {pageNum, totalPages} = this.state;

        if (pageNum < totalPages) {
            this.setState({pageNum: pageNum + 1, updateList: true});
        }
    };

    setPreviousPage = () => {
        const {pageNum} = this.state;

        if (pageNum > 1) {
            this.setState({pageNum: pageNum - 1, updateList: true});
        }
    };

    setPageByNum = (num) => {
        const {pageNum} = this.state;

        if (pageNum !== num) {
            this.setState({pageNum: num, updateList: true});
        }
    };

    resetPageOnBlur = (event) => {
        const {totalPages, pageNum} = this.state;
        const newVal = event.target.value;

        if (!(newVal === '' || newVal > totalPages || newVal < 1 || parseInt(newVal, 10) === pageNum)) {
            this.setState({pageNum: parseInt(newVal, 10), updateList: true});
        }
    };

    render() {
        const {isFetching, isLoadingError, pageData, pageDataCategory, id, ipp} = this.props;
        const {totalPages, pageNum} = this.state;

        if (isFetching) {
            return (
                <article className="news__subpage">
                    <LoadingIndicator/>
                </article>
            );
        };

        if (isLoadingError) {
            return (
                <article className="news__subpage">
                    <Error505Page />
                </article>
            );
        };

        if (!pageData) {
            return null;
        };

        const newPageData = pageData.slice((pageNum - 1) * ipp, pageNum * ipp);

        return (
            <article className="news__subpage">
                <NewsAll
                    pageData={newPageData}
                    pageDataCategory={pageDataCategory}
                    id={id}
                    page={pageNum}
                    setCurrentPage={this.setCurrentPage}
                    resetPageOnBlur={this.resetPageOnBlur}
                    setPageByNum={this.setPageByNum}
                    setNextPage={this.setNextPage}
                    setPreviousPage={this.setPreviousPage}
                    totalPages={totalPages}/>
            </article>
        );
    };
};

NewsSubpage.propTypes = {
    clang: propTypes.string.isRequired,
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(NewsSubpage));



// WEBPACK FOOTER //
// ./src/components/news/NewsSubpage.js